// extracted by mini-css-extract-plugin
module.exports = {"MyCourses":"MyCourses_MyCourses__1-VUE","container":"MyCourses_container__2UDLt","full-container":"MyCourses_full-container__2x4Tx","col-padding":"MyCourses_col-padding__2Nd6p"};